var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7648 19.5171L36.9913 14.5377C39.0037 13.8334 39.0037 10.9875 36.9913 10.2832L22.7648 5.3039C21.3188 4.79779 19.7436 4.79779 18.2975 5.3039L4.07102 10.2832C2.05868 10.9875 2.05868 13.8334 4.07102 14.5377L18.2975 19.5171C19.7436 20.0231 21.3188 20.0231 22.7648 19.5171Z",
    stroke: "#002970",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0542 15.5663V27.403C34.0542 28.5004 33.534 29.5329 32.6523 30.186C26.1212 35.0238 17.195 35.0238 10.664 30.186C9.78225 29.5329 9.26221 28.5004 9.26221 27.403V16.3551",
    stroke: "#002970",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0391 11.283L36.9667 14.9275C37.9144 15.2171 38.5619 16.0919 38.5619 17.0829V28.9915",
    stroke: "#002970",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.562 33.1245V36.0759",
    stroke: "#00BAF2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.1af3631a45eefd2902f37783e56d5758.svg";
export { ForwardRef as ReactComponent };